/**
 * @fileoverview gRPC-Web generated client stub for artifact
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: artifact/service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var artifact_artifact_pb = require('../artifact/artifact_pb.js')

var common_model_pb = require('../common/model_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.artifact = require('./service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.artifact.ArtifactServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.artifact.ArtifactServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.GetArtifactByIdRequest,
 *   !proto.artifact.ArtifactResponse>}
 */
const methodDescriptor_ArtifactService_GetArtifactById = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactService/GetArtifactById',
  grpc.web.MethodType.UNARY,
  proto.artifact.GetArtifactByIdRequest,
  proto.artifact.ArtifactResponse,
  /**
   * @param {!proto.artifact.GetArtifactByIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.GetArtifactByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactServiceClient.prototype.getArtifactById =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactService/GetArtifactById',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_GetArtifactById,
      callback);
};


/**
 * @param {!proto.artifact.GetArtifactByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactServicePromiseClient.prototype.getArtifactById =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactService/GetArtifactById',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_GetArtifactById);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.GetLatestArtifactRequest,
 *   !proto.artifact.ArtifactResponse>}
 */
const methodDescriptor_ArtifactService_GetLatestArtifact = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactService/GetLatestArtifact',
  grpc.web.MethodType.UNARY,
  proto.artifact.GetLatestArtifactRequest,
  proto.artifact.ArtifactResponse,
  /**
   * @param {!proto.artifact.GetLatestArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.GetLatestArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactServiceClient.prototype.getLatestArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactService/GetLatestArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_GetLatestArtifact,
      callback);
};


/**
 * @param {!proto.artifact.GetLatestArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactServicePromiseClient.prototype.getLatestArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactService/GetLatestArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_GetLatestArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.ListArtifactsRequest,
 *   !proto.artifact.ListArtifactsResponse>}
 */
const methodDescriptor_ArtifactService_ListArtifacts = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactService/ListArtifacts',
  grpc.web.MethodType.UNARY,
  proto.artifact.ListArtifactsRequest,
  proto.artifact.ListArtifactsResponse,
  /**
   * @param {!proto.artifact.ListArtifactsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ListArtifactsResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.ListArtifactsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ListArtifactsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ListArtifactsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactServiceClient.prototype.listArtifacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactService/ListArtifacts',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_ListArtifacts,
      callback);
};


/**
 * @param {!proto.artifact.ListArtifactsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ListArtifactsResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactServicePromiseClient.prototype.listArtifacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactService/ListArtifacts',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_ListArtifacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.WriteArtifactRequest,
 *   !proto.artifact.CreateArtifactResponse>}
 */
const methodDescriptor_ArtifactService_CreateArtifact = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactService/CreateArtifact',
  grpc.web.MethodType.UNARY,
  proto.artifact.WriteArtifactRequest,
  proto.artifact.CreateArtifactResponse,
  /**
   * @param {!proto.artifact.WriteArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.CreateArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.WriteArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.CreateArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.CreateArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactServiceClient.prototype.createArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactService/CreateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_CreateArtifact,
      callback);
};


/**
 * @param {!proto.artifact.WriteArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.CreateArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactServicePromiseClient.prototype.createArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactService/CreateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_CreateArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.WriteArtifactRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ArtifactService_UpdateArtifact = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactService/UpdateArtifact',
  grpc.web.MethodType.UNARY,
  proto.artifact.WriteArtifactRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.artifact.WriteArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.artifact.WriteArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactServiceClient.prototype.updateArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactService/UpdateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_UpdateArtifact,
      callback);
};


/**
 * @param {!proto.artifact.WriteArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactServicePromiseClient.prototype.updateArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactService/UpdateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_UpdateArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.UploadDocRequest,
 *   !proto.artifact.ArtifactResponse>}
 */
const methodDescriptor_ArtifactService_UploadDoc = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactService/UploadDoc',
  grpc.web.MethodType.UNARY,
  proto.artifact.UploadDocRequest,
  proto.artifact.ArtifactResponse,
  /**
   * @param {!proto.artifact.UploadDocRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.UploadDocRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactServiceClient.prototype.uploadDoc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactService/UploadDoc',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_UploadDoc,
      callback);
};


/**
 * @param {!proto.artifact.UploadDocRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactServicePromiseClient.prototype.uploadDoc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactService/UploadDoc',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_UploadDoc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.SaveArtifactAsEvidenceRequest,
 *   !proto.artifact.SaveArtifactAsEvidenceResponse>}
 */
const methodDescriptor_ArtifactService_SaveArtifactAsEvidence = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactService/SaveArtifactAsEvidence',
  grpc.web.MethodType.UNARY,
  proto.artifact.SaveArtifactAsEvidenceRequest,
  proto.artifact.SaveArtifactAsEvidenceResponse,
  /**
   * @param {!proto.artifact.SaveArtifactAsEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.SaveArtifactAsEvidenceResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.SaveArtifactAsEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.SaveArtifactAsEvidenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.SaveArtifactAsEvidenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactServiceClient.prototype.saveArtifactAsEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactService/SaveArtifactAsEvidence',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_SaveArtifactAsEvidence,
      callback);
};


/**
 * @param {!proto.artifact.SaveArtifactAsEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.SaveArtifactAsEvidenceResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactServicePromiseClient.prototype.saveArtifactAsEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactService/SaveArtifactAsEvidence',
      request,
      metadata || {},
      methodDescriptor_ArtifactService_SaveArtifactAsEvidence);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.artifact.ArtifactInternalServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.artifact.ArtifactInternalServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.GetArtifactByIdInternalRequest,
 *   !proto.artifact.ArtifactResponse>}
 */
const methodDescriptor_ArtifactInternalService_GetArtifactById = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/GetArtifactById',
  grpc.web.MethodType.UNARY,
  proto.artifact.GetArtifactByIdInternalRequest,
  proto.artifact.ArtifactResponse,
  /**
   * @param {!proto.artifact.GetArtifactByIdInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.GetArtifactByIdInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.getArtifactById =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/GetArtifactById',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_GetArtifactById,
      callback);
};


/**
 * @param {!proto.artifact.GetArtifactByIdInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.getArtifactById =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/GetArtifactById',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_GetArtifactById);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.GetLatestArtifactInternalRequest,
 *   !proto.artifact.ArtifactResponse>}
 */
const methodDescriptor_ArtifactInternalService_GetLatestArtifact = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/GetLatestArtifact',
  grpc.web.MethodType.UNARY,
  proto.artifact.GetLatestArtifactInternalRequest,
  proto.artifact.ArtifactResponse,
  /**
   * @param {!proto.artifact.GetLatestArtifactInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.GetLatestArtifactInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.getLatestArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/GetLatestArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_GetLatestArtifact,
      callback);
};


/**
 * @param {!proto.artifact.GetLatestArtifactInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.getLatestArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/GetLatestArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_GetLatestArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.ListArtifactsInternalRequest,
 *   !proto.artifact.ListArtifactsResponse>}
 */
const methodDescriptor_ArtifactInternalService_ListArtifacts = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/ListArtifacts',
  grpc.web.MethodType.UNARY,
  proto.artifact.ListArtifactsInternalRequest,
  proto.artifact.ListArtifactsResponse,
  /**
   * @param {!proto.artifact.ListArtifactsInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ListArtifactsResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.ListArtifactsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ListArtifactsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ListArtifactsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.listArtifacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ListArtifacts',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ListArtifacts,
      callback);
};


/**
 * @param {!proto.artifact.ListArtifactsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ListArtifactsResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.listArtifacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ListArtifacts',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ListArtifacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.WriteArtifactInternalRequest,
 *   !proto.artifact.CreateArtifactResponse>}
 */
const methodDescriptor_ArtifactInternalService_CreateArtifact = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/CreateArtifact',
  grpc.web.MethodType.UNARY,
  proto.artifact.WriteArtifactInternalRequest,
  proto.artifact.CreateArtifactResponse,
  /**
   * @param {!proto.artifact.WriteArtifactInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.CreateArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.WriteArtifactInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.CreateArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.CreateArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.createArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/CreateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_CreateArtifact,
      callback);
};


/**
 * @param {!proto.artifact.WriteArtifactInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.CreateArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.createArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/CreateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_CreateArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.WriteArtifactInternalRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ArtifactInternalService_UpdateArtifact = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/UpdateArtifact',
  grpc.web.MethodType.UNARY,
  proto.artifact.WriteArtifactInternalRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.artifact.WriteArtifactInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.artifact.WriteArtifactInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.updateArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/UpdateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_UpdateArtifact,
      callback);
};


/**
 * @param {!proto.artifact.WriteArtifactInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.updateArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/UpdateArtifact',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_UpdateArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.ChatCancelledRequest,
 *   !proto.artifact.ChatCancelledResponse>}
 */
const methodDescriptor_ArtifactInternalService_GetIsChatCancelled = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/GetIsChatCancelled',
  grpc.web.MethodType.UNARY,
  proto.artifact.ChatCancelledRequest,
  proto.artifact.ChatCancelledResponse,
  /**
   * @param {!proto.artifact.ChatCancelledRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ChatCancelledResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.ChatCancelledRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ChatCancelledResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ChatCancelledResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.getIsChatCancelled =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/GetIsChatCancelled',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_GetIsChatCancelled,
      callback);
};


/**
 * @param {!proto.artifact.ChatCancelledRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ChatCancelledResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.getIsChatCancelled =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/GetIsChatCancelled',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_GetIsChatCancelled);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.UpdateChatCancelledRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ArtifactInternalService_CancelChat = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/CancelChat',
  grpc.web.MethodType.UNARY,
  proto.artifact.UpdateChatCancelledRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.artifact.UpdateChatCancelledRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.artifact.UpdateChatCancelledRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.cancelChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/CancelChat',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_CancelChat,
      callback);
};


/**
 * @param {!proto.artifact.UpdateChatCancelledRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.cancelChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/CancelChat',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_CancelChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.ListChatUploadsInternalRequest,
 *   !proto.artifact.ListChatUploadsResponse>}
 */
const methodDescriptor_ArtifactInternalService_ListChatUploads = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/ListChatUploads',
  grpc.web.MethodType.UNARY,
  proto.artifact.ListChatUploadsInternalRequest,
  proto.artifact.ListChatUploadsResponse,
  /**
   * @param {!proto.artifact.ListChatUploadsInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ListChatUploadsResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.ListChatUploadsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ListChatUploadsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ListChatUploadsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.listChatUploads =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ListChatUploads',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ListChatUploads,
      callback);
};


/**
 * @param {!proto.artifact.ListChatUploadsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ListChatUploadsResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.listChatUploads =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ListChatUploads',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ListChatUploads);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.HasChatUploadFilesRequest,
 *   !proto.artifact.HasChatUploadFilesResponse>}
 */
const methodDescriptor_ArtifactInternalService_HasChatUploadFiles = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/HasChatUploadFiles',
  grpc.web.MethodType.UNARY,
  proto.artifact.HasChatUploadFilesRequest,
  proto.artifact.HasChatUploadFilesResponse,
  /**
   * @param {!proto.artifact.HasChatUploadFilesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.HasChatUploadFilesResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.HasChatUploadFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.HasChatUploadFilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.HasChatUploadFilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.hasChatUploadFiles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/HasChatUploadFiles',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_HasChatUploadFiles,
      callback);
};


/**
 * @param {!proto.artifact.HasChatUploadFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.HasChatUploadFilesResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.hasChatUploadFiles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/HasChatUploadFiles',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_HasChatUploadFiles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.CreateAgentUploadRequest,
 *   !proto.artifact.CreateAgentUploadResponse>}
 */
const methodDescriptor_ArtifactInternalService_CreateAgentUpload = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/CreateAgentUpload',
  grpc.web.MethodType.UNARY,
  proto.artifact.CreateAgentUploadRequest,
  proto.artifact.CreateAgentUploadResponse,
  /**
   * @param {!proto.artifact.CreateAgentUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.CreateAgentUploadResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.CreateAgentUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.CreateAgentUploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.CreateAgentUploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.createAgentUpload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/CreateAgentUpload',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_CreateAgentUpload,
      callback);
};


/**
 * @param {!proto.artifact.CreateAgentUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.CreateAgentUploadResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.createAgentUpload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/CreateAgentUpload',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_CreateAgentUpload);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.PostArtifactAsEvidenceRequest,
 *   !proto.artifact.PostArtifactAsEvidenceResponse>}
 */
const methodDescriptor_ArtifactInternalService_PostArtifactAsEvidence = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/PostArtifactAsEvidence',
  grpc.web.MethodType.UNARY,
  proto.artifact.PostArtifactAsEvidenceRequest,
  proto.artifact.PostArtifactAsEvidenceResponse,
  /**
   * @param {!proto.artifact.PostArtifactAsEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.PostArtifactAsEvidenceResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.PostArtifactAsEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.PostArtifactAsEvidenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.PostArtifactAsEvidenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.postArtifactAsEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/PostArtifactAsEvidence',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_PostArtifactAsEvidence,
      callback);
};


/**
 * @param {!proto.artifact.PostArtifactAsEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.PostArtifactAsEvidenceResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.postArtifactAsEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/PostArtifactAsEvidence',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_PostArtifactAsEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.ApplyTestProcedureRefinementRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ArtifactInternalService_ApplyTestProcedureRefinement = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/ApplyTestProcedureRefinement',
  grpc.web.MethodType.UNARY,
  proto.artifact.ApplyTestProcedureRefinementRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.artifact.ApplyTestProcedureRefinementRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.artifact.ApplyTestProcedureRefinementRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.applyTestProcedureRefinement =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ApplyTestProcedureRefinement',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ApplyTestProcedureRefinement,
      callback);
};


/**
 * @param {!proto.artifact.ApplyTestProcedureRefinementRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.applyTestProcedureRefinement =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ApplyTestProcedureRefinement',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ApplyTestProcedureRefinement);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.artifact.ApplyControlProcedureRefinementRequest,
 *   !proto.artifact.ApplyControlProcedureRefinementResponse>}
 */
const methodDescriptor_ArtifactInternalService_ApplyControlProcedureRefinement = new grpc.web.MethodDescriptor(
  '/artifact.ArtifactInternalService/ApplyControlProcedureRefinement',
  grpc.web.MethodType.UNARY,
  proto.artifact.ApplyControlProcedureRefinementRequest,
  proto.artifact.ApplyControlProcedureRefinementResponse,
  /**
   * @param {!proto.artifact.ApplyControlProcedureRefinementRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.artifact.ApplyControlProcedureRefinementResponse.deserializeBinary
);


/**
 * @param {!proto.artifact.ApplyControlProcedureRefinementRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.artifact.ApplyControlProcedureRefinementResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.artifact.ApplyControlProcedureRefinementResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.artifact.ArtifactInternalServiceClient.prototype.applyControlProcedureRefinement =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ApplyControlProcedureRefinement',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ApplyControlProcedureRefinement,
      callback);
};


/**
 * @param {!proto.artifact.ApplyControlProcedureRefinementRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.artifact.ApplyControlProcedureRefinementResponse>}
 *     Promise that resolves to the response
 */
proto.artifact.ArtifactInternalServicePromiseClient.prototype.applyControlProcedureRefinement =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/artifact.ArtifactInternalService/ApplyControlProcedureRefinement',
      request,
      metadata || {},
      methodDescriptor_ArtifactInternalService_ApplyControlProcedureRefinement);
};


module.exports = proto.artifact;

